import { createContext, useContext } from 'react';

export interface ThemeContextType {
    primaryColor: string;
    setPrimaryColor: (color: string) => void;
    resetPrimaryColor: () => void;
    isDefaultColor: boolean;
}

export const ThemeContext = createContext<ThemeContextType | undefined>(
    undefined,
);

export const useTheme = () => {
    const context = useContext(ThemeContext);
    if (!context) {
        throw new Error('useTheme must be used within a ThemeProvider');
    }
    return context;
};
